import React, { useState, useEffect } from "react";
import "./lawyerSignup.css";
import NarrowInputField from "../../components/input/new/narrowInputField";
import NarrowDropdown2 from "../../components/input/new/narrowDropdown2";
import SignupImg from "./assets/signupImg.png";
import Footer from "../../components/footer";
import SignupToolbar from "../../components/lawyerToolbar/signupToolbar";
import { useLocation, useNavigate } from "react-router-dom"; // Import useNavigate hook
import { updateLegalInfo } from "../../redux/attorneySlice";
import { useDispatch } from "react-redux";
import IconCheckbox from "../../components/input/new/iconCheckbox";
import { supabase } from "../../supabaseClient";

export default function InvitedSignup() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "",
    zipCode: "",
  });

  const isFormValid =
    formData.firstName.trim() !== "" &&
    formData.lastName.trim() !== "" &&
    formData.phoneNumber.trim() !== "" &&
    formData.zipCode.trim() !== "";

  const [communication, setCommunication] = useState(true);
  const navigate = useNavigate(); // Initialize the navigate function
  const location = useLocation();

  const { user } = location.state || {}; // Destructure the user object from navigation state

  const userMetadata = user.user_metadata || {};

  const dispatch = useDispatch();

  // Generic change handler for form inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      updateLegalInfo({
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.emailAddress,
        phone: formData.phone,
        zipCode: formData.zipCode,
        communicationPreference: communication,
      })
    );
    navigate("/grow/invited/set-password", {
      state: { formData, communication, userMetadata },
    });

    // Process form data here
    console.log("Submitted form data:", formData);
  };

  return (
    <div className="lawyer-signup-container">
      <SignupToolbar />

      {/* Main wrapper */}
      <div className="signup-wrapper">
        {/* Left Side: Intro / Illustration */}
        <div className="left-section">
          <img src={SignupImg} alt="Globe" className="globe-img" />
          <h2 className="left-section-title">Let’s Get You Set Up</h2>
          <p className="left-section-text">
            You have been invited to join your firm on Quidpro
          </p>
          <p className="left-section-text">
            Create your account to start collaborating with your team and
            managing client connections - all in one place
          </p>
        </div>

        {/* Right Side: Sign Up Form */}
        <div className="right-section">
          <form className="signup-form" noValidate>
            {/* User name */}
            <div style={{ display: "flex", gap: "16px", width: "425px" }}>
              <NarrowInputField
                name="firstName"
                title="First Name"
                placeholder="Enter first name"
                isRequired={true}
                value={formData.firstName}
                onChange={handleChange}
                halfWidth={true}
              />
              <NarrowInputField
                name="lastName"
                title="Last Name"
                placeholder="Enter last name"
                isRequired={true}
                value={formData.lastName}
                onChange={handleChange}
                halfWidth={true}
              />
            </div>

            <NarrowInputField
              name="phoneNumber"
              title="Phone Number"
              placeholder="Enter Phone Number"
              isRequired={true}
              value={formData.phoneNumber}
              onChange={handleChange}
            />

            <NarrowInputField
              name="zipCode"
              title="Zipcode"
              placeholder="Enter Zipcode"
              isRequired={true}
              value={formData.zipCode}
              onChange={handleChange}
            />

            {/* Sign up button */}
            <button
              type="submit"
              onClick={handleSubmit}
              className="signup-button"
              disabled={!isFormValid} // Button is disabled when the form is not valid
            >
              Sign up
            </button>

            {/* Already have an account? */}
            <div className="login-redirect">
              Already have an account? <a href="/grow/email">Log in</a>
            </div>

            <div className="contact-checkbox">
              <IconCheckbox
                checked={communication}
                onChange={setCommunication}
                // onClick={(e) => setCommunication(e.target.checked)}
              />
              <p className="contact-text">
                By checking this box, I consent to receive text messages and
                emails from Quidpro with exclusive offers and updates about the
                platform.
              </p>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}
